module.exports = __webpack_public_path__ + "static/img/gws-upi-qr-code.c271499.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gws-upi-qr-code.png
// module id = CBWp
// module chunks = 1